import * as React from 'react';
import { SVGProps } from 'react';

const IconExitSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path d="M2 3h6v1H2zM2 9h6v1H2z" />
    <path d="M2 3h1v7H2zM11 6.5 9 8V5l2 1.5ZM5 6h4v1H5z" />
  </svg>
);
export default IconExitSizeXs;
